import React from 'react';
import { Card, CardContent, Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Button } from '@uplift/ui-v2';
import { Link } from 'react-router-dom';


const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(3),
  },
  title: {
    fontSize: 15,
    fontWeight: 600,
  },
  description: {
    fontSize: 13,
    fontWeight: 400,
  },
}));


type MissingProviderPromptProps = {
  title: string;
  description: string;
  cta: string;
  to: string;
  outlined?: boolean;
};


export const MissingProviderPrompt: React.VFC<MissingProviderPromptProps> = ({ title, description, cta, to, outlined }) => {
  const { classes } = useStyles();

  return (
    <Card>
      <CardContent className={classes.root}>
        <Box mt={2}>
          <Typography className={classes.title} color="textSecondary" align="center">
            {title}
          </Typography>
        </Box>
        <Box mt={0.5}>
          <Typography className={classes.description} color="textSecondary" align="center">
            {description}
          </Typography>
        </Box>
        <Box mt={3}>
          <Button variant={outlined ? 'outlined' : 'contained'} color="secondary" component={Link} to={to}>
            {cta}
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};
